export default "https://cdn-static-staging.gokick.com/assets/44c43e25e1d60214daaa18ce4b143b941a81a79a/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";